module.exports = __webpack_public_path__ + "img/upload-1st-present.abeb5811.png";